import SearchService from '@/services/search'
/**
 * @description Mixin for views that include the `Tree.vue` network graph/list-view component
 */
export default {
  data () {
    return {
      isTreeGraphLoaded: false,
      treeGraphData: [],
      treeGraphError: false
    }
  },
  watch: {
    '$route.params.id' (newSlug, oldSlug) {
      // Set graph loading state to false when fetching a new slug
      if (newSlug !== oldSlug) this.isTreeGraphLoaded = false
    }
  },
  methods: {
    fetchTreeGraphData (searchObject, collaborators = null) {
      this.treeGraphData = []
      this.isTreeGraphLoaded = false

      // List of organisations to exclude, for organisations, this is already set on the searchObject
      if (Array.isArray(collaborators)) { searchObject.scoped_slug_texts = collaborators }

      SearchService.networkGraphData(searchObject).then(data => {
        if (!this.isEmpty(data)) {
          this.treeGraphData = data.map(node => {
            return {
              ...node,
              label: node.label.replace(/(\[*\d+\])+/, ''), // Strip square brackets with inner numbers from labels
              type: this.getMostRelevantOrganisationCategory(node.data.organisation_types).toLowerCase(),
              slug: node.data.slug_values && node.data.slug_values[0]
            }
          })
        }

        this.isTreeGraphLoaded = true
      }).catch(err => {
        this.treeGraphError = this.handleError(err)
        this.isTreeGraphLoaded = true
      })
    }
  }
}
